import { lazy } from 'react';

import type { AppRouteConfig } from '@/App/AppRoutes/types';
import { TERMS_OF_USE_PATH } from '@/components/termsOfUse/types';

const TermsOfUsePage = lazy(() =>
  import('@/components/termsOfUse/TermsOfUsePage').then(({ TermsOfUsePage }) => ({
    default: TermsOfUsePage,
  })),
);

export const TermsOfUseRoute: AppRouteConfig = {
  key: 'terms-of-use-page',
  path: `${TERMS_OF_USE_PATH}/:locale?`,
  component: TermsOfUsePage,
};
